export const CHANNELS = {
  IN_APP: 'In-app',
  EMAIL: 'Email',
  SMS: 'SMS (Twilio)',
  WHATSAPP: 'WhatsApp (Twilio)',
};
